import React, { useEffect, useLayoutEffect } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Cookies from "./Features/Cookies";
import { currentUser, authActions } from "./Features/authSlice";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

//Components
import DashboardLayout from "./Layout/DashboardLayout";
import DashboardHub from "./Pages/DashboardHub";
import SalesDashboard from "./Pages/SalesDashboard";
import DataDashboard from "./Pages/DataDashboard";
import ListingsDashboard from "./Pages/ListingsDashboard";
import StoresDashboard from "./Pages/StoresDashboard";
import MarketplaceDashboard from "./Pages/MarketplaceDashboard";
import SellerOnboardingDashboard from "./Pages/SellerOnboardingDashboard";
import OrderOperationsDashboard from "./Pages/OrderOperationsDashboard";
import Loading from "./Pages/Loading";
import Login from "./Pages/Login";
import Shopkeepers from "./Pages/shopkeeper/ShopKeepers";
import Users from "./Pages/Users/Users";
import PointSystem from "./Pages/PointSystem/PointSystem";
import PlansPage from "./Pages/Plans/PlansPage";
import AddPlans from "./Pages/Plans/AddPlans";
import SubscriptionsPage from "./Pages/subscriptions/SubscriptionsPage";
import RequestPage from "./Pages/Request/RequestPage";
import DataPage from "./Pages/data/DataPage";
import PaymentPage from "./Pages/payment/payment";
import BanksPage from "./Pages/BanksPage";
import DataImport from "./Pages/DataImport";
import RedirectionsTable from "./Pages/ForcedRedirection/RedirectionsTable";
import ForcedRedirections from "./Pages/ForcedRedirection/ForcedRedirections";
import SellerRegistrationRequests from "./Pages/SellerRegistrationRequests/SellerRegistrationRequests";
import Notifications from "./Pages/Notifications/Notifications";
import NotificationsTable from "./Pages/Notifications/NotificationsTable";
import AdminNotifications from "./Pages/AdminNotifications";

import AddTheme from "./Pages/Themes/AddTheme";
import Themes from "./Pages/Themes/Themes";
import UsersDeletionRequests from "./Pages/UsersDeletionRequests/UsersDeletionRequests";
import Modules from "./Pages/Modules/Modules";
import PlanRequests from "./Pages/PlanRequests/PlanRequests";
import ConsumableItems from "./Pages/Pricing/ConsumableItems";
import AddonsRequests from "./Pages/AddonsRequest/AddonsRequests";
import ModulePricing from "./Pages/Pricing/ModulePricing";
import io from "socket.io-client";
import { notificationActions } from "./Features/notificationSlice";
import { toast } from "react-toastify";
import { FiBell } from "react-icons/fi";
import "./Components/NotificationDropdown/Notifications.css";
import ThemesPricing from "./Pages/Pricing/ThemesPricing";
import DeliveryCharges from "./Pages/Pricing/DeliveryCharges";
import OrdersPage from "./Pages/Orders/OrdersPage";
import OrdersStats from "./Pages/Orders/OrdersStats";
import DeliveryCities from "./Pages/MarketplaceOptions/DeliveryCities";
import ShopFeatures from "./Pages/MarketplaceOptions/ShopFeatures";
import MarketplaceSettings from "./Pages/MarketplaceOptions/MarketplaceSettings";
import FeaturedListingsBookingRequests from "./Pages/FeaturedListingsBookingRequests/FeaturedListingsBookingRequests";
import OrdersVouchers from "./Pages/Orders/OrdersVouchers";
import HomePageConfigurations from "./Pages/MarketplaceOptions/HomePageConfigurations";
import PlatformCommision from "./Pages/Pricing/PlatformCommision";
import ProcessSellerPayments from "./Pages/Orders/ProcessSellerPayments";
import OrdersSellerPayments from "./Pages/Orders/OrdersSellerPayments";
import CreateOrder from "./Pages/CreateOrder/CreateOrder";
import CreateOrderRedirect from "./Components/DeliverForYouCreateOrder/CreateOrderRedirect";
import SalesAndDeals from "./Pages/MarketplaceOptions/SalesAndDeals";
import SalesAndDealsFormPage from "./Pages/MarketplaceOptions/SalesAndDealsFormPage";
import LegacyDeliveryForYouOrders from "./Pages/DeliveryForYou[Legacy]/DeliveryForYouOrders";
import LegacyDeliverForYouCreateOrder from "./Pages/DeliverForYouCreateOrder[Legacy]/DeliverForYouCreateOrder";
import LegacyDeliveryForYouOrdersStats from "./Pages/DeliveryForYou[Legacy]/DeliveryForYouOrdersStats";
import LegacyDeliveryForYouSellerPayments from "./Pages/DeliveryForYou[Legacy]/DeliveryForYouSellerPayments";
import LegacyProcessSellerPayments from "./Pages/DeliveryForYou[Legacy]/ProcessSellerPayments";
import LegacyDeliveryForYouVouchers from "./Pages/DeliveryForYou[Legacy]/DeliveryForYouVouchers";
import DeliveryPartners from "./Pages/Orders/DeliveryPartners";
import LegacyDeliveryCharges from "./Pages/Pricing/LegacyDeliveryCharges";
import ListingReviewsDummy from "./Pages/ListingReviewsDummy/ListingReviewsDummy";
import ListingReviewsApprovals from "./Pages/ListingReviewsApprovals/ListingReviewsApprovals";
import AlertMessages from "./Pages/AlertMessages/AlertMessages";
import ApiTokens from "./Pages/ApiTokens/ApiTokens";
import AddAlertMessage from "./Pages/AlertMessages/AddAlertMessage";
import DailyExpenses from "./Pages/DailyExpenses/DailyExpenses";
const RedirectComponent = () => {
  const { user } = useSelector((state) => state.auth);
  const token = process.env.REACT_APP_ENV === "production" ? Cookies.get("ad_access") : process.env.REACT_APP_ENV === "uat" ? Cookies.get("aaccess") : Cookies.get("ad_token");
  const dispatch = useDispatch();
  const refreshToken = localStorage.getItem("refreshToken");
  const socketRef = React.useRef();

  // Check if the refresh token JWT has expired client-side to avoid a doomed
  // API call. The backend refresh token has a 1h expiry.
  const isRefreshTokenExpired = (tokenStr) => {
    if (!tokenStr) return true;
    try {
      const raw = tokenStr.replace("bearer ", "").replace("Bearer ", "");
      const payload = JSON.parse(atob(raw.split(".")[1]));
      return payload.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  };

  // Run once on mount: restore session if we have a valid token, otherwise logout.
  // We intentionally do NOT include `token` in the dependency array because the
  // access token cookie changes on every API response (the backend sets a fresh
  // cookie), which would cause this effect to re-fire on every request and loop.
  useLayoutEffect(() => {
    if (token && !isRefreshTokenExpired(refreshToken)) {
      if (!user) {
        dispatch(currentUser(refreshToken));
      }
    } else if (!token || isRefreshTokenExpired(refreshToken)) {
      dispatch(authActions.logout());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const permissions = user?.permissionObject;
  const userType = user?.user_type;

  useEffect(() => {
    const CustomToast = ({ notificationData }) => (
      <div className="notif-toast">
        <div className="notif-toast-icon">
          <FiBell />
        </div>
        <div className="notif-toast-body">
          <p className="notif-toast-title">{notificationData.title || "Notification"}</p>
          <p className="notif-toast-text">{notificationData.body}</p>
        </div>
      </div>
    );
    const notificationCountCallback = (notificationData) => {
      dispatch(notificationActions.notificationCount(notificationData));
    };
    const subscriptionsCallback = (notificationData) => {
      toast(<CustomToast notificationData={notificationData} />, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 4000,
        pauseOnHover: true,
        closeButton: true,
        className: "notif-toast-container",
      });
    };
    const NotificationCallback = (notificationData) => {
      toast(<CustomToast notificationData={notificationData} />, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 4000,
        pauseOnHover: true,
        closeButton: true,
        className: "notif-toast-container",
      });
    };
    const connectErrorCallback = (err) => {
      console.error("Socket connection error:", err.message);
    };
    const reconnectCallback = () => {
      const currentToken = process.env.REACT_APP_ENV === "production" ? Cookies.get("ad_access") : process.env.REACT_APP_ENV === "uat" ? Cookies.get("aaccess") : Cookies.get("ad_token");
      if (currentToken) {
        axios
          .get(process.env.REACT_APP_API_URL + `/notifications/unread?user_id=${user?.user_id}&limit=1&offset=0`, { withCredentials: true })
          .then((res) => {
            const count = res?.data?.data?.pagination?.count;
            if (count !== undefined) {
              dispatch(notificationActions.notificationCount({ unreadNotificationsCount: count }));
            }
          })
          .catch((err) => console.error("Error refreshing notification count on reconnect:", err));
      }
    };
    const getToken = () => {
      return process.env.REACT_APP_ENV === "production" ? Cookies.get("ad_access") : process.env.REACT_APP_ENV === "uat" ? Cookies.get("aaccess") : Cookies.get("ad_token");
    };
    if (token && token !== "undefined") {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      socketRef.current = io(process.env.REACT_APP_API_URL, {
        auth: (cb) => cb({ token: getToken() }),
      });
      const socket = socketRef.current;
      socket.on("notificationCount", notificationCountCallback);
      socket.on("subscriptions", subscriptionsCallback);
      socket.on("addonsRequest", NotificationCallback);
      socket.on("deliveryOrder", NotificationCallback);
      socket.on("checkout", NotificationCallback);
      socket.on("connect_error", connectErrorCallback);
      socket.on("reconnect", reconnectCallback);
      return () => {
        socket.off("notificationCount", notificationCountCallback);
        socket.off("subscriptions", subscriptionsCallback);
        socket.off("addonsRequest", NotificationCallback);
        socket.off("deliveryOrder", NotificationCallback);
        socket.off("checkout", NotificationCallback);
        socket.off("connect_error", connectErrorCallback);
        socket.off("reconnect", reconnectCallback);
      };
    } else {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    }
  }, [dispatch, token, user?.user_id]);

  return (
    <Routes>
      {user && token ? (
        <Route
          path="*"
          element={
            <Routes>
              <Route path="/" element={<DashboardLayout />}>
                <Route path="/" element={<DashboardHub />} />
                {(userType === "super-admin" || Number(permissions?.AnalyticsDashboards) === 1) && (
                  <Route path="dashboard" element={<Outlet />}>
                    <Route path="sales" element={<SalesDashboard />} />
                    <Route path="data" element={<DataDashboard />} />
                    <Route path="listings" element={<ListingsDashboard />} />
                    <Route path="stores" element={<StoresDashboard />} />
                    <Route path="marketplace" element={<MarketplaceDashboard />} />
                    <Route path="seller-onboarding" element={<SellerOnboardingDashboard />} />
                    <Route path="order-operations" element={<OrderOperationsDashboard />} />
                    <Route path="" element={<DashboardHub />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.MarketplaceExpenses) === 1) && (
                  <Route path="marketplace-expenses" element={<DailyExpenses />} />
                )}
                {(userType === "super-admin" || Number(permissions?.Shopkeeper) === 1) && <Route path="Shopkeepers" element={<Shopkeepers />} />}
                {(userType === "super-admin" || Number(permissions?.User) === 1) && (
                  <Route path="user" element={<Outlet />}>
                    <Route path="" element={<Users />} />
                  </Route>
                )}

                {(userType === "super-admin" || Number(permissions?.DataImport) === 1) && (
                  <Route path="ImportRequests" element={<Outlet />}>
                    <Route path="" element={<DataImport />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.Payment) === 1) && (
                  <Route path="Payment" element={<Outlet />}>
                    <Route path="" element={<PaymentPage />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.Subscription) === 1) && (
                  <Route path="subscription" element={<Outlet />}>
                    <Route path="plans" element={<PlansPage />} />
                    <Route path="addplans" element={<AddPlans />} />
                    <Route path="request-details" element={<RequestPage />} />
                    <Route path="modules" element={<Modules />} />

                    <Route path="plan-requests" element={<PlanRequests />} />

                    <Route path="" element={<SubscriptionsPage />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.Pricing) === 1) && (
                  <Route path="pricing" element={<Outlet />}>
                    <Route path="consumable-items" index element={<ConsumableItems />} />
                    <Route path="modules-pricing" element={<ModulePricing />} />
                    <Route path="themes-pricing" element={<ThemesPricing />} />
                    <Route path="delivery-charges" element={<DeliveryCharges />} />
                    <Route path="legacy-delivery-charges" element={<LegacyDeliveryCharges />} />
                    <Route path="platform-commission" element={<PlatformCommision />} />
                    <Route path="daily-expenses" element={<DailyExpenses />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.AddonsRequests) === 1) && (
                  <Route path="/addons-requests" element={<Outlet />}>
                    <Route path="" element={<AddonsRequests />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.PointSystem) === 1) && (
                  <Route path="Pointsystem" element={<Outlet />}>
                    <Route path="" element={<PointSystem />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.Bank) === 1) && (
                  <Route path="bank" element={<Outlet />}>
                    <Route path="" element={<BanksPage />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.ForcedRedirections) === 1) && (
                  <Route path="forced-redirections" element={<Outlet />}>
                    <Route path="" element={<RedirectionsTable />} />
                    <Route path="add-redirection" element={<ForcedRedirections />} />
                  </Route>
                )}
                {userType === "super-admin" && <Route path="api-tokens" element={<ApiTokens />} />}
                {(userType === "super-admin" || Number(permissions?.AlertMessages) === 1) && (
                  <Route path="alert-messages" element={<Outlet />}>
                    <Route path="" element={<AlertMessages />} />
                    <Route path="add" element={<AddAlertMessage />} />
                    <Route path="edit/:id" element={<AddAlertMessage />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.RegistrationRequests) === 1) && (
                  <Route path="seller-registration" element={<Outlet />}>
                    <Route path="" element={<SellerRegistrationRequests />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.DeliveryOrder) === 1) && (
                  <>
                    <Route path="orders" element={<Outlet />}>
                      <Route index element={<OrdersPage />} />
                      <Route path="create" element={<CreateOrder />} />
                      <Route path="stats" element={<OrdersStats />} />
                      <Route path="vouchers" element={<OrdersVouchers />} />
                      <Route path="delivery-partners" element={<DeliveryPartners />} />
                      <Route path="seller-payments" element={<Outlet />}>
                        <Route index element={<OrdersSellerPayments />} />
                        <Route path="process-payments" element={<ProcessSellerPayments />} />
                      </Route>
                    </Route>

                    <Route path="delivery-for-you" element={<Outlet />}>
                      <Route path="" element={<Navigate to="/delivery-for-you/orders" />} />
                      <Route path="orders" element={<Outlet />}>
                        <Route path="" element={<LegacyDeliveryForYouOrders />} />
                        <Route path="create" element={<LegacyDeliverForYouCreateOrder />} />
                      </Route>
                      <Route path="stats" element={<LegacyDeliveryForYouOrdersStats />} />
                      <Route path="vouchers" element={<LegacyDeliveryForYouVouchers />} />
                      <Route path="seller-payments" element={<Outlet />}>
                        <Route index element={<LegacyDeliveryForYouSellerPayments />} />
                        <Route path="process-payments" element={<LegacyProcessSellerPayments />} />
                      </Route>
                    </Route>
                    {/* <Route path="products/:listing" element={<Outlet />} /> */}
                    <Route path="products/:listing" element={<CreateOrderRedirect />} />
                  </>
                )}

                {(userType === "super-admin" || Number(permissions?.Themes) === 1) && (
                  <Route path="theme" element={<Outlet />}>
                    <Route path="add" element={<AddTheme />} />
                    <Route path="" element={<Themes />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.MarketplaceOptions) === 1) && (
                  <Route path="marketplace-options" element={<Outlet />}>
                    <Route path="shop-features" index element={<ShopFeatures />} />
                    <Route path="settings" element={<MarketplaceSettings />} />
                    <Route path="delivery-cities" element={<DeliveryCities />} />
                    <Route path="configs" element={<HomePageConfigurations />} />
                    <Route path="sales-deals" element={<SalesAndDeals />} />
                    <Route path="sales-deals/create" element={<SalesAndDealsFormPage />} />
                    <Route path="sales-deals/edit/:id" element={<SalesAndDealsFormPage />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.ListingReviews) === 1) && (
                  <Route path="listing-reviews" element={<Outlet />}>
                    <Route path="dummy" element={<ListingReviewsDummy />} />
                    <Route path="approvals" element={<ListingReviewsApprovals />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.Component) === 1) && (
                  <Route path="data" element={<Outlet />}>
                    <Route path="" element={<DataPage />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.Notifications) === 1) && (
                  <Route path="notification-center" element={<Outlet />}>
                    <Route path="" element={<NotificationsTable />} />
                    <Route path="send" element={<Notifications />} />
                  </Route>
                )}
                <Route path="notifications" element={<AdminNotifications />} />
                {/* {userType === "super-admin" && (
                  <Route path="theme" element={<Outlet />}>
                    <Route path="add" element={<AddTheme />} />
                    <Route path="" element={<Themes />} />
                  </Route>
                )}{" "} */}
                {(userType === "super-admin" || Number(permissions?.UserDeletionRequests) === 1) && (
                  <Route path="users-deletion-requests" element={<Outlet />}>
                    <Route path="" element={<UsersDeletionRequests />} />
                  </Route>
                )}
                {(userType === "super-admin" || Number(permissions?.FeaturedListingsBookings) === 1) && (
                  <Route path="featured-listings-bookings" element={<Outlet />}>
                    <Route path="" element={<FeaturedListingsBookingRequests />} />
                  </Route>
                )}
              </Route>
              <Route exact path="/login" element={<Navigate to="/" />} />
              <Route exact path="*" element={<Navigate to="/" />} />
            </Routes>
          }
        />
      ) : (
        <Route
          path="*"
          element={
            <Routes>
              <Route exact path="/login" element={<Login />} />
              <Route path="/set-password/:token" element={<Loading />} />
              <Route exact path="*" element={token ? <Outlet /> : <Navigate to="/login" />} />
            </Routes>
          }
        />
      )}
    </Routes>
  );
};

export default RedirectComponent;
